import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { TikTokRouteTracker } from "@/hooks/useTikTok";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/hooks/useAuth";
import { CheckoutProvider } from "@/hooks/useCheckout";
import { StorefrontProvider } from "@/hooks/useStorefront";
import CatalogPage from "@/pages/CatalogPage";
import HomePage from "@/pages/HomePage";
import HairCareGuidePage from "@/pages/HairCareGuidePage";
import UrduGuidePage from "@/pages/UrduGuidePage";
import BlogIndexPage from "@/pages/BlogIndexPage";
import BlogPostPage from "@/pages/BlogPostPage";
import TrackOrderPage from "@/pages/TrackOrderPage";
import AdminReviews from "@/pages/admin/AdminReviews";
import ProductDetailPage from "@/pages/ProductDetailPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminProductForm from "@/pages/admin/AdminProductForm";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminSubscribers from "@/pages/admin/AdminSubscribers";
import AdminAbandoned from "@/pages/admin/AdminAbandoned";

function RequireAdmin({ children }) {
    const { user, loading } = useAuth();
    if (loading)
        return (
            <div className="min-h-screen flex items-center justify-center bg-cream">
                <div className="animate-pulse text-forest-800 font-serif">
                    Loading…
                </div>
            </div>
        );
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
}

function App() {
    return (
        <div className="App">
            <Toaster
                position="top-center"
                richColors
                toastOptions={{
                    style: { fontFamily: '"Plus Jakarta Sans", sans-serif' },
                }}
            />
            <AuthProvider>
                <StorefrontProvider>
                    <CheckoutProvider>
                        <BrowserRouter>
                    <TikTokRouteTracker />
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/shop" element={<CatalogPage />} />
                        <Route path="/hair-care-guide" element={<HairCareGuidePage />} />
                        <Route path="/ur/hair-care-guide" element={<UrduGuidePage />} />
                        <Route path="/blog" element={<BlogIndexPage />} />
                        <Route path="/blog/:slug" element={<BlogPostPage />} />
                        <Route path="/ur/blog" element={<BlogIndexPage lang="ur" />} />
                        <Route path="/ur/blog/:slug" element={<BlogPostPage lang="ur" />} />
                        <Route path="/track-order" element={<TrackOrderPage />} />
                        <Route
                            path="/product/:slug"
                            element={<ProductDetailPage />}
                        />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route
                            path="/admin"
                            element={
                                <RequireAdmin>
                                    <AdminLayout />
                                </RequireAdmin>
                            }
                        >
                            <Route index element={<AdminAnalytics />} />
                            <Route path="orders" element={<AdminOrders />} />
                            <Route path="products" element={<AdminProducts />} />
                            <Route path="products/new" element={<AdminProductForm />} />
                            <Route path="products/:id" element={<AdminProductForm />} />
                            <Route path="abandoned" element={<AdminAbandoned />} />
                            <Route path="subscribers" element={<AdminSubscribers />} />
                            <Route path="reviews" element={<AdminReviews />} />
                            <Route path="settings" element={<AdminSettings />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                        </BrowserRouter>
                    </CheckoutProvider>
                </StorefrontProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
